import React from "react";

const DesempenhoPage = () => {
    return <div>Desempenho</div>
}

export default DesempenhoPage;